import { FunctionComponent, ReactElement, useEffect, useState } from 'react'

import Icon from '@/components/HeroIcons'

import {
  hasMin8LettersRegExp,
  hasEspecialCharacterRegExp,
  hasNumberRegExp,
  hasLowerAndUppercaseLettersRegExp,
} from '@/utils/regExp'

interface PasswordTipsProps {
  password?: string
}

const PasswordTips: FunctionComponent<PasswordTipsProps> = ({ password }) => {
  const [hasMinLetters, setHasMinLetters] = useState<boolean>()
  const [hasSpecialCharacter, setHasSpecialCharacter] = useState<boolean>()
  const [hasNumber, setHasNumber] = useState<boolean>()
  const [hasUpperAndLowerLettters, setHasUpperAndLowerLetters] =
    useState<boolean>()

  const chooseIcon = (state: boolean): ReactElement => {
    if (state === undefined || state === null) {
      return <Icon name="dot" width="16px" themeColor={['neutral', '900']} />
    }

    if (state) {
      return <Icon name="check" width="24px" themeColor={['success', '500']} />
    }

    return <Icon name="close" width="24px" themeColor={['danger', '500']} />
  }

  useEffect(() => {
    if (password) {
      hasMin8LettersRegExp.test(password)
        ? setHasMinLetters(true)
        : setHasMinLetters(false)
      hasEspecialCharacterRegExp.test(password)
        ? setHasSpecialCharacter(true)
        : setHasSpecialCharacter(false)
      hasNumberRegExp.test(password) ? setHasNumber(true) : setHasNumber(false)
      hasLowerAndUppercaseLettersRegExp.test(password)
        ? setHasUpperAndLowerLetters(true)
        : setHasUpperAndLowerLetters(false)

      return
    }

    setHasMinLetters(null)
    setHasSpecialCharacter(null)
    setHasNumber(null)
    setHasUpperAndLowerLetters(null)
  }, [password])

  return (
    <ul className="password-tips__root">
      <li className="password-tips__tip">
        {chooseIcon(hasMinLetters)}
        <span>Ter no mínimo, 8 caracteres;</span>
      </li>
      <li className="password-tips__tip">
        {chooseIcon(hasSpecialCharacter)}
        <span>Ter um caracter especial, como @#%;</span>
      </li>
      <li className="password-tips__tip">
        {chooseIcon(hasNumber)}
        <span>Ter um número;</span>
      </li>
      <li className="password-tips__tip">
        {chooseIcon(hasUpperAndLowerLettters)}
        <span>Combinar letras maiúsculas e minúsculas;</span>
      </li>
    </ul>
  )
}

export { PasswordTips }
